//Post Override Request
export const POST_OVERRIDEREQUEST_REQUEST = "POST_OVERRIDEREQUEST_REQUEST";
export const POST_OVERRIDEREQUEST_SUCCESS = "POST_OVERRIDEREQUEST_SUCCESS";
export const POST_OVERRIDEREQUEST_FAILURE = "POST_OVERRIDEREQUEST_FAILURE";

//Patch Override Request
export const PATCH_OVERRIDEREQUEST_REQUEST = "PATCH_OVERRIDEREQUEST_REQUEST";
export const PATCH_OVERRIDEREQUEST_SUCCESS = "PATCH_OVERRIDEREQUEST_SUCCESS";
export const PATCH_OVERRIDEREQUEST_FAILURE = "PATCH_OVERRIDEREQUEST_FAILURE";

//Fetch Override Request By Id
export const FETCH_OVERRIDEREQUEST_REQUEST = "FETCH_OVERRIDEREQUEST_REQUEST";
export const FETCH_OVERRIDEREQUEST_SUCCESS = "FETCH_OVERRIDEREQUEST_SUCCESS";
export const FETCH_OVERRIDEREQUEST_FAILURE = "FETCH_OVERRIDEREQUEST_FAILURE";

//Fetch Override Request list
export const FETCH_OVERRIDEREQUEST_LIST_REQUEST = "FETCH_OVERRIDEREQUEST_LIST_REQUEST";
export const FETCH_OVERRIDEREQUEST_LIST_SUCCESS = "FETCH_OVERRIDEREQUEST_LIST_SUCCESS";
export const FETCH_OVERRIDEREQUEST_LIST_FAILURE = "FETCH_OVERRIDEREQUEST_LIST_FAILURE";
